// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.success[data-v-34c4bf6e] {
    color: green;
    background-color: #f7f7f7;
    padding: 10px;
    margin-bottom: 5px;
}
.set-password-form[data-v-34c4bf6e] {
    max-width: 500px;
    margin: 10px auto;
}
.submit[data-v-34c4bf6e] {
    background-color: var(--graphileon-color);
    color: white;
    padding: 5px 10px;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
